import { Component, Inject, OnInit } from '@angular/core';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { formatDateTime, numericInputLimit } from '../../../shared/commonutils/helper';
import { AddEditRevenueDialogData, SalisburyddData } from '../../../../interfaces/pricematrixmodel';
import { DailyDosingService } from '../../../../services/daily-dosing.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DatetimePickerInputComponent } from '../../../shared/components/datetime-picker-input/datetime-picker-input.component';

@Component({
  selector: 'app-update-salisbury-dosing',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    DragDropModule,
    DatetimePickerInputComponent
  ],
  templateUrl: './update-salisbury-dosing.component.html',
  styleUrl: './update-salisbury-dosing.component.scss'
})
export class UpdateSalisburyDosingComponent implements OnInit {

  sdForm = new FormGroup({
    id: new FormControl(0, null),
    loads: new FormControl(0, null),
    other: new FormControl(0, null),
    tank: new FormControl('', null),
    dtc: new FormControl(new Date(), null)
  });
  constructor(public dialogRef: MatDialogRef<UpdateSalisburyDosingComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: SalisburyddData, private service: DailyDosingService) {      
    
      console.log("Dialog data received in UpdateSalisburyDosingComponent:", dialogData);

    this.sdForm.patchValue({
      id: this.dialogData.id,
      loads: this.dialogData.loads,
      other: this.dialogData.other,
      tank: this.dialogData.tank ? this.dialogData.tank : '',
      dtc: this.dialogData.dtc ? new Date(this.dialogData.dtc) : null 
    });
  }

  ngOnInit(): void {
  }

  onSave(): void {
    if (this.sdForm.valid) {
      if(this.sdForm.get('loads')?.value === null && this.sdForm.get('other')?.value === null){
        this.dialogRef.close(true);
      }else{
        var dt = this.sdForm.get('dtc')?.value;
        var updatedDt = formatDateTime(dt);
        const payload = {
          id: this.sdForm.get('id')?.value,
          datecaptured: updatedDt,
          loads: this.sdForm.get('loads')?.value,
          other: this.sdForm.get('other')?.value
        };
        this.service.saveSalisburyDosing(payload).subscribe((response) => {
          console.log('Save response:', response);
          this.dialogRef.close(true);
        });
      }
    }else{
      this.sdForm.markAllAsTouched();
    }
  }
    
  onClose(): void {
    this.dialogRef.close(false);
  }

  roundOff(event: Event, maxValue: number, maxDecimals: number, controlName: string): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;
    let isNegetive = false;
    
    if(val.startsWith('-')){
      isNegetive = true;
      val = val.substring(1);
    }
    val = numericInputLimit(event, maxValue, maxDecimals);
    
    
    if(isNegetive){
      val = '-'+val;
    }
    input.value = val;

    // 6. Parsing for the backing variables
    const isValueEmpty = val === '' || val === '.' || val === '-';
    if (isValueEmpty) {
      this.sdForm.get(controlName)?.setValue(null, { emitEvent: false });
    } else if (val.endsWith('.')) {
      this.sdForm.get(controlName)?.setErrors({ 'incompleteDecimal': true });
    } else {
      const parsedValue = parseFloat(val);
      this.sdForm.get(controlName)?.setValue(parsedValue, { emitEvent: false });
    }

    requestAnimationFrame(() => {
      if (document.activeElement === input) {
        input.value = val;   // put "14.10" back so next keystroke appends correctly
      }
    });
  }
}
